<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="750px"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <!-- layer_popWrap -->
      <div class="dialog-container" style="width: 750px">
        <div class="dialog-header">
          <h3 class="header-title">최근 참석자</h3>
        </div>
        <div class="dataTable" style="min-height: 200px">
          <div class="popup_tel_wrap">
            <div class="list" style="width: 35%">
              <span class="list_title">최근 회의 목록</span>
              <table style="border-top: 2px solid #333333; margin-top: 10px">
                <tr v-for="(listItem, index) in calData" :key="index">
                  <td
                    :class="{ activeTarget: listItem.bindActive }"
                    style="
                      text-align: center;
                      padding-top: 5px;
                      cursor: pointer;
                      font-size: 16px;
                      padding-left: 0;
                    "
                    @click="selectBookmark(listItem)"
                  >
                    {{ listItem.title }}
                  </td>
                </tr>
              </table>
            </div>
            <!-- /.list -->

            <div class="list_on" style="width: 63%; padding-left: 0">
              <span class="list_title">선택 목록</span>

              <table
                class="member_list"
                cellpadding="0"
                cellspacing="0"
                style="width: 95%; border-top: 2px solid #333333; margin-top: 10px"
              >
                <caption>
                  이 표는 구성되어 있습니다.
                </caption>

                <colgroup>
                  <col style="width: 35%" />
                  <col style="width: 25%" />
                  <col style="width: 40%" />
                </colgroup>
                <tbody v-if="selectedBookmarkList !== null">
                  <tr class="line">
                    <td>
                      <span class="">참석자</span>
                    </td>
                    <td>
                      <span class="">직급</span>
                    </td>
                    <td>
                      <span class="">부서</span>
                    </td>
                  </tr>
                  <tr
                    class="con"
                    v-for="(list, index) in selectedBookmarkList.attendees"
                    :key="index"
                  >
                    <td>{{ list.name ? list.name : list.email }}</td>
                    <td>
                      {{
                        list.DUTY_NM === "팀장"
                          ? list.DUTY_NM
                          : list.positionName
                      }}
                    </td>
                    <td>{{ list.name ? list.DEPT_NM : "-" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- //.list_on -->
          </div>
          <!-- // .popup_tel_wrap -->
        </div>
        <!-- //<div class="dataTable> -->
        <div class="btnArea">
          <button class="close-btn" @click="closeDialog()">
            닫기
          </button>
          <button class="invite-btn" @click="submitBookmark">
            완료
          </button>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Util from "@/util";
import debounce from "lodash.debounce";

export default {
  components: {},
  props: ["dialog", "attendees", "closeDialog"],
  data() {
    return {
      userKey: null,
      email: null,
      loading: true,
      error: null,
      bookmarks: [],
      selectedBookmarkList: null,
      checkedMembers: [] /* 체크박스 유저 정보 */,
    };
  },
  computed: {
    calData() {
      let newObj = this.bookmarks.map(function(element, index) {
        let attendees_str = "";
        if (element.attendees.length === 1) {
          if (element.attendees[0].name) {
            attendees_str = `${element.attendees[0].name}`;
          } else {
            attendees_str = `${element.attendees[0].email}`;
          }
        } else if (element.attendees.length > 1) {
          if (element.attendees[0].name) {
            attendees_str = `${element.attendees[0].name} 외 ${element.attendees
              .length - 1}명`;
          } else {
            attendees_str = `${element.attendees[0].email} 외 ${element
              .attendees.length - 1}명`;
          }
        }
        element["attendeesString"] = attendees_str;
        element["bindActive"] = false;
        return element;
      });

      return newObj;
    },
  },
  watch: {
    dialog: function(newVal) {
      if (newVal === true) {
        this.search();
      }
    },
  },
  mounted() {
    this.loading = false;
  },
  methods: {
    init() {
      this.userKey = decodeURI(decodeURIComponent(Util.getParam("userKey")));
      this.email =
        decodeURI(decodeURIComponent(Util.getParam("userKey"))) + "@krx.co.kr";

      this.error = null;
      this.selectedBookmarkList = null;
      this.bookmarks.forEach(obj => {
        obj.bindActive = false;
      });
    },
    close() {
      this.init();
      this.closeDialog(undefined);
    },

    search: debounce(async function(siteName) {
      this.userKey = decodeURI(decodeURIComponent(Util.getParam("userKey")));
      this.email =
        decodeURI(decodeURIComponent(Util.getParam("userKey"))) + "@krx.co.kr";

      let email = "";

      if (this.userKey) {
        // 연계 파트
        email = this.email;
      } else {
        email = this.$store.state.user.email;
      }
      let params = {
        creator: this.$store.state.user.email ? this.$store.state.user.email : email,
      };

      await this.$http
        .get("/api/v1/meetings/recentlyMeetings", { params: params })
        .then(response => {
          let data = response.data;
          console.log(data);
          this.bookmarks = data;
        })
        .catch(error => {
          console.log(error);
        });
    }, 200),
    selectBookmark(bookmark) {
      this.bookmarks.forEach(obj => {
        obj.bindActive = false;
      });
      bookmark.bindActive = true;
      this.selectedBookmarkList = bookmark;
    },
    submitBookmark() {
      this.closeDialog(this.selectedBookmarkList);
      this.init();
    },
  },
};
</script>
<style scoped>
a {
  color: #464646;
  font-weight: 300;
}
.seltabcontent .seltab {
  width: 9%;
}
.p_ad {
  width: 42%;
  border: 1px solid #989898;
  border-radius: 5px;
  padding: 30px 15px 25px 15px;
  position: relative;
  font-weight: 500;
}

.seltab_r .scroll_tit li {
  float: left;
  height: 23px;
  padding-top: 7px;
  padding-bottom: 3px;
  text-align: center;
  border-top: 2px solid #fa4242;
  border-bottom: 1px solid #fa4242;
}

.checkbox {
  position: relative;
  font-size: 12px;
  float: none;
  padding: 0;
}
.checkbox input[type="checkbox"] {
  display: none;
}
.checkbox input[type="checkbox"] + label:before {
  position: unset;
  border: none;
}

.popContainer .checkbox input[type="checkbox"] + label {
  border: 1px solid #7f7f7f;
  display: inline-block;
  width: 12px;
  height: 12px;
  background: #fff;
  cursor: pointer;
  position: unset;
  padding: 0;
}
.popContainer .checkbox :after {
  display: block;
  clear: both;
  content: "";
}
.popContainer .checkbox input[type="checkbox"]:checked + label:before {
  position: unset;
  left: 0;
  top: 0;
  background: #fff;
  width: 0;
  height: 0;
  border: none;
}

.popContainer .checkbox input[type="checkbox"]:checked + label:after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 10px;
  height: 10px;
  background: #fa4242;
}

/* 선택목록 스크롤 바 */
.mCustomScrollbar::-webkit-scrollbar {
  width: 6px;
}
.mCustomScrollbar::-webkit-scrollbar-track {
  background-color: transparent;
}
.mCustomScrollbar::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: gray;
}
.mCustomScrollbar::-webkit-scrollbar-button {
  width: 0;
  height: 0;
}
.seltab .btn_com {
  display: inline-block;
  width: 60px;
  height: 30px;
  line-height: 30px;
  padding: 0;
  color: white;
}
.btn_com {
  color: white;
}
.btn_linedf {
  color: #fa4242;
}

/* 체크박스 */
.btn_check_box > .container-checkbox {
  display: block;
  position: relative;
  cursor: pointer;
  font-size: 17px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  float: left;
  margin-right: 10px;
  font-size: 17px;
  width: 100%;
}

.btn_check_box > .container-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  width: 100%;
  height: 30px;
  z-index: 100;
  top: -16px;
  right: 0px;
}

.btn_check_box > .container-checkbox .checkmark {
  position: absolute;
  border: 1px solid #7f7f7f;
  display: inline-block;
  width: 12px;
  height: 12px;
  background: #fff;
  cursor: pointer;
  top: -5px;
  right: 18px;
}

/* On mouse-over, add a grey background color */
.btn_check_box > .container-checkbox:hover input ~ .checkmark {
}

/* When the checkbox is checked, add a blue background */
.btn_check_box > .container-checkbox input:checked ~ .checkmark {
  background-color: white;
}

/* Create the checkmark/indicator (hidden when not checked) */
.btn_check_box > .container-checkbox .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.btn_check_box > .container-checkbox input:checked ~ .checkmark:after {
  display: block;
  content: "";
  top: 1px;
  left: 1px;
  width: 8px;
  height: 8px;
  background: #fa4242;
}

/* Style the checkmark/indicator */
.btn_check_box > .container-checkbox .checkmark:after {
  left: 8px;
  top: 4px;
  width: 5px;
  height: 10px;
  border-width: 0 3px 3px 0;
}

.btn_check_box {
  padding-top: 4px;
}

.bookmark-delete-btn {
  float: right;
  border: none;
  border-radius: 5px;
  background: #0d99de;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #fff;
  width: 80px;
  text-align: center;
  height: 30px;
  line-height: 30px;
}

.activeTarget {
  color: #604af4;
}

.layout-close-btn {
  padding: 6px 15px;
  border: none;
  border-radius: 5px;
  background: #1757a1;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #fff;
  letter-spacing: -1px;
  margin-left: 0;
}

.popup-wrap {
  width: 100%;
  height: 300px;
  background: red;
}

.list_title {
  font-size: 14px;
  font-weight: 500;
  color: #666;
}

.dialog-container td {
  height: 40px;
}
.btnArea {
  display: flex;
  justify-content: end;
}

.invite-btn {
  background-color: #604af3;
  color: white;
  width: 100px;
  height: 48px;
  border-radius: 8px;
  margin: 0 5px;
  font-size: 15px;
}
.close-btn {
  width: 82px;
  height: 48px;
  border-radius: 8px;
  background: #f2f2f2;
  color: #1f2e3d;
  margin: 0 5px;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/RecentlyBookmarkDialog.vue